module.exports = __webpack_public_path__ + "img/spk.9aa5daf7.png";